"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAssetsToJSON = exports.AdAssetsFromJSONTyped = exports.AdAssetsFromJSON = exports.instanceOfAdAssets = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdAssets interface.
 */
function instanceOfAdAssets(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAssets = instanceOfAdAssets;
function AdAssetsFromJSON(json) {
    return AdAssetsFromJSONTyped(json, false);
}
exports.AdAssetsFromJSON = AdAssetsFromJSON;
function AdAssetsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetId': !(0, runtime_1.exists)(json, 'asset_id') ? undefined : json['asset_id'],
        'companionAssetId': !(0, runtime_1.exists)(json, 'companion_asset_id') ? undefined : json['companion_asset_id'],
        'logoAssetId': !(0, runtime_1.exists)(json, 'logo_asset_id') ? undefined : json['logo_asset_id'],
        'canvasAssetId': !(0, runtime_1.exists)(json, 'canvas_asset_id') ? undefined : json['canvas_asset_id'],
    };
}
exports.AdAssetsFromJSONTyped = AdAssetsFromJSONTyped;
function AdAssetsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_id': value.assetId,
        'companion_asset_id': value.companionAssetId,
        'logo_asset_id': value.logoAssetId,
        'canvas_asset_id': value.canvasAssetId,
    };
}
exports.AdAssetsToJSON = AdAssetsToJSON;
